const ALLOWED_VIDEO_FORMATS = ['mp4', 'webm'];

export const isAllowedVideoFormat = (src) =>
  typeof src === 'string'
    ? ALLOWED_VIDEO_FORMATS.includes(src.split('.').pop().toLowerCase())
    : false;
